import { render, staticRenderFns } from "./Phrases.vue?vue&type=template&id=24c42bba&scoped=true&"
import script from "./Phrases.vue?vue&type=script&lang=js&"
export * from "./Phrases.vue?vue&type=script&lang=js&"
import style0 from "./Phrases.vue?vue&type=style&index=0&id=24c42bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c42bba",
  null
  
)

export default component.exports